import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UzurvDirectivesModule } from '@uzurv/core';
import { MaterialModule } from '../../../app/material.module';
import { AlertDialogModule } from '../alert-dialog/alert-dialog.module';
import { FeeScheduleChangeRequestDialogComponent } from './fee-schedule-change-request-dialog.component';

@NgModule({
  declarations: [FeeScheduleChangeRequestDialogComponent],
  imports: [CommonModule, ReactiveFormsModule, FormsModule, UzurvDirectivesModule, MaterialModule, AlertDialogModule],
  exports: [FeeScheduleChangeRequestDialogComponent]
})
export class FeeScheduleChangeRequestDialogModule {}
